import React from "react";

import {
  Form,
  FormMessage,
  st,
  OrderFullDecorator,
  OrderItemDecorator,
  FormControl,
  Button,
  PureComponent,
} from "lib/index";
import OrderBillItem from "./OrderBillItem";
import OrderedItemOrderBillItem from "./OrderedItemOrderBillItem";
import OrderedFieldOrderBillItem from "./OrderedFieldOrderBillItem";

const getMyAgent = function () {
  if (st.authorize.company.reseller) {
    return { id: 100, name: "SocialTravel" };
  } else {
    return { id: st.authorize.company.id, name: st.authorize.company.name };
  }
};

const getOrderPossibleAgents = ({ currentCompany, order }) => {
  if (currentCompany.reseller) return [{ id: 100, name: "SocialTravel" }];
  if (st.authorize.company.agent) return [{ id: currentCompany.id, name: currentCompany.name }];
  return order.company.id === currentCompany.id
    ? currentCompany.getPossibleAgents({
        withMyself: false,
        enabled_by_agent: true,
      })
    : [currentCompany];
};

export default class NewOrderItemsForm extends React.PureComponent {
  state = {
    newOrderItem: new OrderItemDecorator({
      _new: true,
      uuid: st.generateUuid(),
    }),
  };

  componentDidMount() {
    const myAgent = getMyAgent();
    this.handleAgentChange(...myAgent);

    if (this.props.currentCompany.reseller || st.authorize.company.agent) {
      this.handleResellerOrder();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.order.order_items.find((item) => item.uuid === this.state.newOrderItem.uuid)) {
      this.setState({
        newOrderItem: new OrderItemDecorator({
          _new: true,
          uuid: st.generateUuid(),
        }),
      });
    }
  }

  handleResellerOrder() {
    const myAgent = getMyAgent();
    this.handleAgentChange(...myAgent);
    const { order, onOrderUpdate } = this.props;
    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        agent: { ...myAgent },
        affiliate_id: st.authorize.company.reseller ? "" + this.props.currentCompany.id : undefined,
      })
    );
  }

  handleOrderedItemChange(nextOrderedItem) {
    const { order, onOrderUpdate } = this.props;
    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        ordered_product_pricelist_items: order.ordered_product_pricelist_items.map((oi) => {
          return oi.uuid === nextOrderedItem.uuid ? nextOrderedItem : oi;
        }),
      })
    );
  }

  handleOrderedFieldChange(newOrderedField) {
    const { order, onOrderUpdate } = this.props;
    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        ordered_product_order_fields: order.ordered_product_order_fields.map((of) => {
          return of.uuid === newOrderedField.uuid ? newOrderedField : of;
        }),
        ordered_product_pricelist_items: order.ordered_product_pricelist_items.map((x) => {
          if (x.ordered_product_order_fields.find((of) => of.uuid === newOrderedField.uuid)) {
            return {
              ...x,
              ordered_product_order_fields: x.ordered_product_order_fields.map((of) => {
                return of.uuid === newOrderedField.uuid ? newOrderedField : of;
              }),
            };
          } else {
            return x;
          }
        }),
        order_customer_participants: order.order_customer_participants.map((x) => {
          if (x.ordered_product_order_fields.find((orderedField) => orderedField.uuid === newOrderedField.uuid)) {
            return {
              ...x,
              ordered_product_order_fields: x.ordered_product_order_fields.map((orderedField) => {
                return orderedField.uuid === newOrderedField.uuid ? newOrderedField : orderedField;
              }),
            };
          } else {
            return x;
          }
        }),
      })
    );
  }

  handleOrderItemAdd(attributes = {}) {
    const { order, onOrderUpdate } = this.props;
    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        order_items: order.order_items.concat([
          {
            uuid: st.generateUuid(),
            item_type: "product_custom",
            base_item: false,
            name: "",
            quantity: 1,
            unit_price: { value: 0, currency: order.product_price_currency },
            position: Math.max(0, ...order.order_items.map((oi) => oi.position)) + 100,
            ...attributes,
          },
        ]),
      })
    );
  }

  handleOrderItemPropChange(orderItem, prop, value) {
    const { order, onOrderUpdate } = this.props;
    if (orderItem._new) {
      this.handleOrderItemAdd({
        uuid: orderItem.uuid,
        [prop]: value,
      });
      return;
    }
    const nextOrderItem = {
      ...orderItem,
      [prop]: value,
    };
    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        order_items: order.order_items.map((item) => (item.uuid === nextOrderItem.uuid ? nextOrderItem : item)),
      })
    );
  }

  handleOrderItemRemove(orderItem) {
    const { order, onOrderUpdate } = this.props;
    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        order_items: order.order_items.filter((i) => i.uuid !== orderItem.uuid),
      })
    );
  }

  handleAgentChange(agent) {
    const { order, onOrderUpdate } = this.props;
    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        agent,
      })
    );
  }

  handleAgentCommisionChange(agent_commision_amount) {
    const { order, onOrderUpdate } = this.props;
    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        agent_commision_amount,
        custom_agent_commision_amount: true,
      })
    );
  }

  handleResetCustomAgentCommisionAmountClick() {
    const { order, onOrderUpdate, onValidate } = this.props;
    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        custom_agent_commision_amount: false,
      })
    );
    onValidate();
  }

  handleSubmit(event) {
    const { onSave } = this.props;
    event.preventDefault();
    onSave();
  }

  renderAgentSection() {
    const { currentCompany, order, onValidate } = this.props;
    const isSupplier = order.company.id === currentCompany.id;
    const isReseller = currentCompany.reseller || st.authorize.company.agent;
    const agents = getOrderPossibleAgents({ currentCompany, order });

    return (
      <div>
        {currentCompany.agent && (
          <div>
            <h5>{I18n.humanAttributeName("order", "agent")}</h5>
            <FormControl.Select
              placeholder={I18n.t("papp.orders.NewOrderItemsForm.select_agent")}
              includeBlank
              value={order.agent ? currentCompany.id : null}
              onChange={(agentId) => this.handleAgentChange(agents.find((c) => c.id === agentId))}
              onBlur={onValidate}
              options={agents.map((c) => [c.id, c.name])}
              disabled={true}
            />
            <FormControl.FormGroup inline label={I18n.humanAttributeName("order", "agent_commision")}>
              <FormControl.Money
                value={order.agent_commision_amount}
                onChange={this.handleAgentCommisionChange.bind(this)}
                onBlur={onValidate}
                min={0}
                defaultCurrency={order.product_price_currency}
                disabled={true}
              />

              {/* {order.custom_agent_commision_amount && (
                <Button
                  as="a"
                  size="small"
                  color="blue"
                  className="u-marginLeft"
                  onClick={this.handleResetCustomAgentCommisionAmountClick.bind(
                    this
                  )}
                  content={I18n.t(
                    "papp.orders.NewOrderItemsForm.reset_agent_commision"
                  )}
                />
              )} */}
            </FormControl.FormGroup>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { currentCompany, order, valid, loading, errors, onValidate } = this.props;
    const agents = getOrderPossibleAgents({ currentCompany, order });
    const showAgentSection = !!order.agent || agents.length > 0;

    return (
      <Form onSubmit={this.handleSubmit.bind(this)} error={!valid}>
        {!!errors.base && <FormMessage error={errors.base} />}

        {order.ordered_product_pricelist_items.map((orderedItem) => {
          return (
            <OrderedItemOrderBillItem
              key={orderedItem.uuid}
              orderedItem={orderedItem}
              name={`order.ordered_product_pricelist_items[${orderedItem.uuid}]`}
              errors={errors}
              onChange={this.handleOrderedItemChange.bind(this)}
              onBlur={onValidate}
            />
          );
        })}

        {order.order_items
          .filter((item) => !["product_item", "product_option", "product_custom"].includes(item.item_type))
          .map((item) => (
            <OrderBillItem
              key={`order.order_items[${item.uuid}]`}
              itemName={item.name}
              itemQuantity={item.quantity}
              itemUnitPrice={item.unit_price}
              itemTotalPrice={item.total_price}
            />
          ))}

        {(order.priced_ordered_fields.length > 0 ||
          !!order.order_customer_participants.find((p) => p.priced_ordered_fields.length > 0)) && [
          <h5 key="options-header">{I18n.t("papp.orders.NewOrderItemsForm.product_options")}</h5>,

          order.priced_ordered_fields.map((orderedField) => (
            <OrderedFieldOrderBillItem
              orderedField={orderedField}
              key={`order.ordered_product_order_fields[${orderedField.uuid}]`}
              name={`order.ordered_product_order_fields[${orderedField.uuid}]`}
              errors={errors}
              onChange={this.handleOrderedFieldChange.bind(this)}
              onBlur={onValidate}
            />
          )),

          order.order_customer_participants
            .filter((p) => p.priced_ordered_fields.length > 0)
            .map((participant) => [
              <h5 key={`order.order_customer_participants[${participant.uuid}]`}>{participant.display_name}</h5>,
              ...participant.priced_ordered_fields.map((orderedField) => (
                <OrderedFieldOrderBillItem
                  orderedField={orderedField}
                  key={`order.order_customer_participants[${participant.uuid}].ordered_product_order_fields[${orderedField.uuid}]`}
                  name={`order.order_customer_participants[${participant.uuid}].ordered_product_order_fields[${orderedField.uuid}]`}
                  errors={errors}
                  onChange={this.handleOrderedFieldChange.bind(this)}
                  onBlur={onValidate}
                />
              )),
            ]),
        ]}
        {(!currentCompany.reseller || !st.authorize.company.agent) && (
          <div>
            <h5>{I18n.t("papp.orders.NewOrderItemsForm.other_order_items")}</h5>
            {order.order_items
              .filter((item) => item.item_type === "product_custom")
              .concat([this.state.newOrderItem])
              .map((item) =>
                item._new ? (
                  <OrderBillItem
                    key={`order.order_items[${item.uuid}]`}
                    itemQuantity=""
                    itemNameEditable
                    onChange={this.handleOrderItemPropChange.bind(this, item)}
                    onBlur={onValidate}
                  />
                ) : (
                  <OrderBillItem
                    key={`order.order_items[${item.uuid}]`}
                    valid={errors.hasValidProp(`order.order_items[${item.uuid}]`)}
                    itemName={item.name}
                    itemNameEditable
                    itemQuantity={item.quantity}
                    itemQuantityEditable
                    itemUnitPrice={item.unit_price}
                    itemUnitPriceEditable
                    itemTotalPrice={item.total_price}
                    defaultCurrency={
                      order.product_price_currency || order.company.default_product_price_currency || "EUR"
                    }
                    controlType="number"
                    onChange={this.handleOrderItemPropChange.bind(this, item)}
                    onBlur={onValidate}
                    onRemove={this.handleOrderItemRemove.bind(this, item)}
                  />
                )
              )}
          </div>
        )}

        {showAgentSection && this.renderAgentSection()}

        <button type="submit" disabled={loading} hidden />
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/NewOrderModal/NewOrderItemsForm/NewOrderItemsForm.jsx